import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (<Route {...rest} render={props => {
    return (
      rest.authen.isLogin ? (
        <Component {...props} />
      ) : (<Redirect to={{
        pathname: process.env.PUBLIC_URL + '/login'
      }} />
        )
    )
  }} />
  )
}

const mapStateToProps = state => (
  { authen: state.authen }
)

export default connect(mapStateToProps)(PrivateRoute)